import { Clear } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { BaseClearIconButtonProps } from './BaseClearIconButton.types';

/**
 * The `BaseClearIconButton` is a combination of both the
 * MUI {@link IconButton} and the MUI {@link Clear} icon to create
 * a replica of the clear icons that the MUI autocomplete has.
 *
 * @param classes - {@link BaseClearIconButtonProps.classes classes} description.
 * @param size - {@link BaseClearIconButtonProps.size size} description.
 * @param fontSize - {@link BaseClearIconButtonProps.fontSize fontSize} description.
 * @param onClick - {@link BaseClearIconButtonProps.onClick onClick} description.
 */
export const BaseClearIconButton = ({
    classes,
    size,
    fontSize,
    onClick,
}: BaseClearIconButtonProps) => {
    return (
        <IconButton
            classes={{
                ...classes,
            }}
            onClick={onClick}
            size={size}
        >
            <Clear fontSize={fontSize} />
        </IconButton>
    );
};